const hasOwn = {}.hasOwnProperty;

// @ts-ignore
export function cs(...params: any[]) {
  const classes = [];

  for (const arg of params) {
    if (!arg) continue;

    const argType = typeof arg;

    if (argType === "string" || argType === "number") {
      classes.push(arg);
    } else if (Array.isArray(arg)) {
      classes.push(cs.apply(null, arg));
    } else if (argType === "object") {
      for (const key in arg) {
        if (hasOwn.call(arg, key) && arg[key]) {
          classes.push(key);
        }
      }
    }
  }

  return classes.join(" ");
}
